import { QueryFunction } from '@tanstack/react-query';
import {
  ClassifierConfiguration,
  ClassifierConfigurationResponse,
} from 'src/types/configurations';
import { getCompatibleAuthTokenHttp } from '../utils/enhancedAuthTokenHttp';

const getClassifierConfiguration: QueryFunction<
  ClassifierConfiguration,
  ['/configurations/Classifier']
> = async () => {
  const authTokenHttp = await getCompatibleAuthTokenHttp();
  const response = await authTokenHttp<ClassifierConfigurationResponse>(
    '/configurations/Classifier',
    {
      method: 'GET',
    },
  );

  if (response.data) return response.data.configuration;
  throw new Error('Failed to fetch Classifier configuration');
};

export default getClassifierConfiguration;
